<template>
    <div>
       <section class="worldcup worldcup--banner-wheel" :class="{'login': currentUser}">
            <b-container>
                <div class="worldcup__count worldcup__desktop">
                    <img :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/bg-login.png`" alt="box">
                    <div class="content">
                        <a class="d-flex align-items-center justify-content-center" v-if="!currentUser" href="javascript:void(0)" @click="$bvModal.show('loginModal')">
                            <span class="text-center">{{'ĐĂNG\nNHẬP'}}</span>
                        </a>
                        <p v-else>
                            <span>bạn có</span>
                            <span class="count">{{userTurn}}</span>
                            <span class="turns">lượt quay</span>
                        </p>
                    </div>
                </div>
                <div class="worldcup__banner" v-if="isTimeShow">
                    <div class="event-total">
                        <TitleWheel :isMobile="$device.isMobileOrTablet" />
                        <span class="number">
                            <AnimatedNumber :value="amount" :format-value="formatToPrice" :duration="duration" />
                        </span>
                    </div>
                    <div class="worldcup__banner-text worldcup__desktop">
                        <div class="list-box">
                            <button class="box-item box-login" v-if="!currentUser" @click="moveToWheel('login')">
                                <img :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/section-wheel/login-action.png`" />
                            </button>
                            <button class="box-item box-recharge" @click="moveToWheel('deposit')">
                                <img :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/section-wheel/recharge2tr.png`" />
                            </button>
                            <button class="box-item box-bet" @click="moveToWheel('bet')">
                                <img :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/section-wheel/bet-min.png`" />
                            </button>
                        </div>
                    </div>
                </div>
                <div class="worldcup__wheel hc-luckywheel">
                    <div class="hc-luckywheel-container">
                        <div class="hc-luckywheel-inner">
                             <CanvasPlayer
                             :isMobile="$device.isMobileOrTablet"
                             :isTurn="isTurn"
                             :prizeKey="prizeKey"
                            />
                        </div>
                        <div v-if="$device.isMobileOrTablet && isTimeShow" class="count-wheel">
                            <div v-if="currentUser" class="login">Bạn hiện có <span>{{userTurn}} lượt quay </span></div>
                            <div v-else class="login-request">ĐĂNG NHẬP NHẬN LƯỢT QUAY MIỄN PHÍ</div>
                        </div>
                        <div :class="['luckywheek-wrapper', !currentUser ? 'mt-2' : '']" v-if="isTimeShow">
                            <div class="luckywheel-spin d-flex" v-if="$device.isDesktop || $device.isMobileOrTablet && currentUser">
                                <button :disabled="currentUser && userTurn == 0 || currentUser && isRoll" :class="['btn-hc-luckywheel', currentUser && userTurn == 0 ? 'btn-off': '']"  @click="getPlayTurns(1)">
                                    <img :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/section-wheel/btn_1luot.png`" alt="wheel">
                                </button>
                                <button :disabled="currentUser && userTurn < 10 || currentUser && isRoll" :class="['btn-hc-luckywheel', currentUser && userTurn < 10 ? 'btn-off': '']" @click="getPlayTurns(10)">
                                    <img :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/section-wheel/btn_10luot.png`" alt="wheel">
                                </button>
                            </div>
                            <div class="luckywheel-spin text-center" v-if="!currentUser && $device.isMobileOrTablet">
                                <button class="btn-hc-luckywheel login" @click="$bvModal.show('loginModal')">
                                    <img :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/section-wheel/login-mb.png`" alt="wheel">
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </b-container>
        </section>
        <div class="line-section" v-if="$device.isDesktop">
            <img class="w-100" :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/section-wheel/line-section.png`" />
        </div>
        <WinWoldcupModal
            :dataRoll="dataRoll"
            :prizeKey="prizeKey"
            :isMobile="this.$device.isMobileOrTablet"
            :userTurn="userTurn"
            @emitDataRollWheel="emitDataRollWheel"
        />
    </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import { mapState } from 'vuex';
import AnimatedNumber from 'animated-number-vue';
import CanvasPlayer from './common/canvas-player.vue';
import TitleWheel from './common/title-wheel.vue';
import WinWoldcupModal from './modal/win-woldcup-modal.vue';
// eslint-disable-next-line import/no-unresolved
import { numberWithCommas } from '@/helper/index.js';

export default {
    data() {
        return {
            eventworldcupInfo: null,
            isLogin: false,
            amount: 250000000,
            prizeKey: '',
            isTurn: false,
            typeRoll: 1,
            timeOut: 0,
            isRoll: false,
            duration: 4000,
            isTimeShow: false
        };
    },
    components: {
        CanvasPlayer,
        WinWoldcupModal,
        TitleWheel,
        AnimatedNumber
    },
    mounted() {
        if (this.currentUser) {
            this.getDataTurns();
        }
        setTimeout(() => {
            this.isTimeShow = true;
        }, 1000);
    },
    computed: {
        currentUser() {
            return this.$store.state.user;
        },
        ...mapState('event/worldcup-wheel', {
            userTurn: state => state.wheelEvent.userTurn,
            dataRoll: state => state.wheelEvent.dataWheel
        })
    },
    watch: {
        dataRoll(data) {
            if (data && data.length === 1) {
                this.prizeKey = data[0].prizeKey;
            } else {
                this.prizeKey = 'quay10luot';
            }
            this.timeOut = this.typeRoll === 1 ? 5000 : 6300;
            this.isTurn = true;
            setTimeout(() => {
                this.isTurn = false;
                this.$bvModal.show('winSeagameModal');
                this.isRoll = false;
            }, this.timeOut);
        }
    },
    methods: {
        async emitDataRollWheel(value) {
            if (value) {
                await this.getPlayTurns(value);
            }
        },
        formatToPrice(value) {
            return numberWithCommas(value.toFixed(0), ',');
        },
        moveToWheel(item) {
            if (item === 'login') {
                this.$bvModal.show('loginModal');
            }
            if (item === 'bet') {
                this.$router.push('/the-thao');
            }
            if (item === 'deposit') {
                if (this.currentUser) {
                    this.$router.push('/user/deposit?tab=0');
                } else {
                    this.$bvModal.show('loginModal');
                }
            }
        },
        async getDataTurns() {
            try {
                await this.$store.dispatch('event/worldcup-wheel/getDataTurns');
            } catch (e) {
                console.log(e);
            }
        },
        async getPlayTurns(data) {
            if (this.currentUser) {
                this.typeRoll = data;
                this.isRoll = true;
                try {
                    await this.$store.dispatch('event/worldcup-wheel/getRollTurns', data);
                    this.getDataTurns();
                    await this.$store.dispatch('event/worldcup-wheel/getRewards');
                    setTimeout(() => {
                        this.$store.dispatch('event/worldcup-wheel/getDailyWinner');
                    }, 5000);
                } catch (e) {
                    if (e.response.data.status === 'NOT_ENOUGH_NUMBER_OF_TURNS') {
                        await this.$store.dispatch('event/worldcup-wheel/getDataTurns');
                    }
                }
            } else {
                this.$bvModal.show('loginModal');
            }
        }
    }
};
</script>
